import { useEffect, useRef } from 'react'

import { isEqual, noop } from 'lodash'

export const useWatcher = <V extends Record<string, unknown>>(
  cb: (prevDeps: V) => void | (() => void),
  deps: V,
  options: { shouldRunOnMount?: boolean } = { shouldRunOnMount: true }
) => {
  const ref = useRef<V>(undefined)

  useEffect(() => {
    const prev = ref.current

    if (
      !prev ||
      Object.keys(deps).some(key => !isEqual(deps[key], prev[key]))
    ) {
      ref.current = deps

      if (prev || options.shouldRunOnMount) {
        return cb(prev || ({} as V))
      }
    }

    return noop
  }, [deps, cb, options.shouldRunOnMount])
}
